// libs
import { styled } from '@nykaa/ui-components';

export const ListContainer = styled.div<{ isPopUp?: boolean; columnCount?: number }>`
  margin: ${({ theme }) => theme.spacing.spacing0};
  scroll-behavior: smooth;
  // @ts-expect-error - filterSurface is a custom property not in UI components ColorTokens type
  background-color: ${({ theme }) => theme.colors.filterSurface};
  // @ts-expect-error - filterBackdropFilter is a custom property not in UI components ColorTokens type
  backdrop-filter: blur(${({ theme }) => theme.colors.filterBackdropFilter}px);
  &::-webkit-scrollbar {
    height: ${({ theme }) => theme.spacing.spacing20};
    background-color: ${({ theme }) => theme.colors.surface20};
  }
  &::-webkit-scrollbar-thumb {
    height: ${({ theme }) => theme.spacing.spacing20};
    border-radius: ${({ theme }) => theme.spacing.spacing60};
    background-color: ${({ theme }) => theme.colors.surface30};
  }
  ${({ isPopUp, theme }) =>
    isPopUp &&
    `display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    padding: ${theme.spacing.spacing100};
    padding-right: ${theme.spacing.spacing0};
    padding-bottom: ${theme.spacing.spacing0};
    max-height: 50vh;
  `};
  ${({ columnCount, isPopUp }) =>
    isPopUp &&
    (columnCount === 1 ? `width: 352px` : columnCount === 2 ? `width: 560px` : `width: 752px`)};
`;

export const LetterHeading = styled.div<{ isDisabled: boolean }>`
  ${({ theme }) => theme.typography.subTitleMedium};
  margin: ${({ theme }) => `${theme.spacing.spacing40} 0`};
  padding: ${({ theme }) => `0 ${theme.spacing.spacing40}`};
  ${({ isDisabled }) =>
    isDisabled &&
    `opacity: 0.2;
    transition: 400ms opacity ease-in-out;
    `};
`;

export const FallbackText = styled.p`
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
`;
